var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MinusIcon, PlusIcon } from "@heroicons/react/24/outline";
import { useContext, useState } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { toast } from "react-toastify";
import { assignTaskToUserRequest, removeTaskFromUserRequest, } from "../../../api/api";
import { PIPELINE_ADD_USER_TO_TASK, PIPELINE_REMOVE_USER_FROM_TASK, } from "../../../constants";
import { ActivePipelineContext } from "../../../providers/ActivePipelineContextProvider";
import { UserContext } from "../../../providers/UserContextProvider";
import { LoadingOval } from "../../Loading/Loading";
function UserAssignementSelection({ task, onUserAdd, onUserDelete }) {
    const { state: { users }, } = useContext(UserContext);
    const { dispatch } = useContext(ActivePipelineContext);
    const [loading, setLoading] = useState(false);
    const availableUsers = users.filter((user) => {
        var _a;
        return !((_a = task.assigned_users) !== null && _a !== void 0 ? _a : []).some((assignedUser) => assignedUser.id === user.id);
    });
    const assignUser = (user) => __awaiter(this, void 0, void 0, function* () {
        try {
            setLoading(true);
            yield assignTaskToUserRequest(user.id, task.id);
            dispatch({
                type: PIPELINE_ADD_USER_TO_TASK,
                payload: {
                    taskId: task.id,
                    user,
                },
            });
            onUserAdd(user);
        }
        catch (error) {
            console.error(error);
            toast.error(__("Failed to assign user", "quicktasker"));
        }
        finally {
            setLoading(false);
        }
    });
    const removeUser = (user) => __awaiter(this, void 0, void 0, function* () {
        try {
            setLoading(true);
            yield removeTaskFromUserRequest(user.id, task.id);
            dispatch({
                type: PIPELINE_REMOVE_USER_FROM_TASK,
                payload: {
                    taskId: task.id,
                    userId: user.id,
                },
            });
            onUserDelete(user);
        }
        catch (error) {
            console.error(error);
            toast.error(__("Failed to remove user", "quicktasker"));
        }
        finally {
            setLoading(false);
        }
    });
    return (_jsxs("div", { className: "wpqt-flex wpqt-w-[320px] wpqt-flex-col", children: [_jsx(UserAssignementSection, { sectionTitle: __("Assigned users", "quicktasker"), users: task.assigned_users, onItemSelect: removeUser, ActionIcon: MinusIcon, actionIconClasses: "wpqt-icon-red", noUsersText: __("No users assigned", "quicktasker") }), _jsx(UserAssignementSection, { sectionTitle: __("Assign a user", "quicktasker"), users: availableUsers, onItemSelect: assignUser, actionIconClasses: "wpqt-icon-green", noUsersText: __("No users available to assign", "quicktasker") }), loading && (_jsx("div", { className: "wpqt-flex wpqt-justify-center", children: _jsx(LoadingOval, { width: "30", height: "30" }) }))] }));
}
function UserAssignementSection({ sectionTitle, onItemSelect = () => { }, users = [], ActionIcon = PlusIcon, actionIconClasses, noUsersText, }) {
    return (_jsxs("div", { className: "wpqt-mb-2", children: [_jsx("div", { className: "wpqt-mb-2 wpqt-text-lg", children: sectionTitle }), users.map((user) => {
                return (_jsxs("div", { onClick: (e) => {
                        e.stopPropagation();
                        onItemSelect(user);
                    }, className: "wpqt-flex wpqt-cursor-pointer wpqt-items-center wpqt-px-2 wpqt-py-1 hover:wpqt-bg-gray-100", children: [_jsxs("div", { className: "wpqt-flex wpqt-flex-col", children: [_jsx("div", { children: user.name }), _jsx("div", { className: "wpqt-italic", children: user.description })] }), _jsx(ActionIcon, { className: `wpqt-ml-auto wpqt-size-5 ${actionIconClasses}` })] }, user.id));
            }), users.length === 0 && _jsx("div", { children: noUsersText })] }));
}
export { UserAssignementSelection };
